import StoreUpdateEvents from "../constants/events/StoreUpdateEvents";
import UIInteractionEvents from "../constants/events/UIInteractionEvents";
import LoadingStates from "../constants/states/LoadingStates";
import ActionResultEvents from "../constants/events/ActionResultEvents";
import SecureBaseStore from "./SecureBaseStore";

class PrivateMySpacesState {
    constructor(
        mySpacesLoadingState,
        listedSpaces,
        unlistedSpaces) {
        this.mySpacesLoadingState = mySpacesLoadingState;
        this.listedSpaces = listedSpaces;
        this.unlistedSpaces = unlistedSpaces;
    }

    equals(other) {
        return this.mySpacesLoadingState === other.mySpacesLoadingState &&
            this.listedSpaces === other.listedSpaces &&
            this.unlistedSpaces === other.unlistedSpaces;

    }
}

class ImmutableMySpacesStateBuilder {

    constructor() {
        this.mySpacesLoadingState = LoadingStates.INITIALIZED;
        this.listedSpaces = [];
        this.unlistedSpaces = [];
    }

    setFromState(state) {
        return this.setMySpacesLoadingState(state.mySpacesLoadingState)
            .setListedSpaces(state.listedSpaces)
            .setUnlistedSpaces(state.unlistedSpaces);
    }

    setMySpacesLoadingState(loadingState) {
        this.mySpacesLoadingState = loadingState;
        return this;
    }

    setListedSpaces(spaces) {
        this.listedSpaces = spaces;
        return this;
    }

    setUnlistedSpaces(spaces) {
        this.unlistedSpaces = spaces;
        return this;
    }

    build() {
        return Object.freeze(
            new PrivateMySpacesState(this.mySpacesLoadingState, this.listedSpaces, this.unlistedSpaces));
    }
}


class PrivateMySpacesStore extends SecureBaseStore {

    constructor() {
        super(StoreUpdateEvents.PRIVATE_MY_SPACES_STORE_UPDATE, ImmutableMySpacesStateBuilder);
        this.subscribeToEvent(ActionResultEvents.MY_SPACES_LOADED, this.handleMySpaceLoaded);
        this.subscribeToEvent(UIInteractionEvents.GET_MY_SPACES, this.handleMySpacesLoading);
        this.subscribeToEvent(UIInteractionEvents.MY_SPACE_UNMOUNTED, this.resetStore);
        this.subscribeToEvent(UIInteractionEvents.MY_SPACES_UNLIST_SPACE_BUTTON_CLICKED, this.resetStore);
        this.subscribeToEvent(UIInteractionEvents.MY_SPACES_LIST_SPACE_BUTTON_CLICKED, this.resetStore);
    }

    handleMySpacesLoading = (topic, data) => {
        return new ImmutableMySpacesStateBuilder()
            .setFromState(this.state)
            .setMySpacesLoadingState(LoadingStates.LOADING)
            .build();
    };

    handleMySpaceLoaded = (topic, data) => {
        return new ImmutableMySpacesStateBuilder()
            .setFromState(this.state)
            .setMySpacesLoadingState(LoadingStates.FINISHED_LOADING)
            .setUnlistedSpaces(data.unlistedSpaces)
            .setListedSpaces(data.listedSpaces)
            .build();
    }

}

export default new PrivateMySpacesStore();